// @flow
import classnames from 'classnames';

import css from '@styles/catalogFilters';

const caretDown = '/images/caret-down.svg';
const caretUp = '/images/caret-up.svg';

type TProps = {
  name: string,
  className?: string,
  showingContent: boolean,
  activeFilterCount?: number,
  onClick: () => void
};

function FilterTab ({
  name,
  className,
  showingContent,
  activeFilterCount = 0,
  onClick
}: TProps) {
  return (
    <h5
      className={classnames(css.tab, className, {
        [css.openTab]: showingContent
      })}
      onClick={onClick}>
      {name} {activeFilterCount > 0 ? `(${activeFilterCount})` : ''}
      <img
        src={showingContent ? caretUp : caretDown}
        alt={`${showingContent ? 'open' : 'closed'} caret`}
        style={{ marginLeft: activeFilterCount > 0 ? 12 : 28, width: 8 }}
      />
    </h5>
  );
}

export default FilterTab;
